module.exports = __webpack_public_path__ + "static/media/arrow-right.82f382c8.svg";